export const getSignInSettings = (state) => state.ingreso;
export const menuSettings = (state) => state.menu;
export const colors = (state) => state.colores;
export const empresaPortal = (state) => state.empresa;
